import { useAction } from "../../../../hooks";
import { getContent, getContentObject, parseDynamicSocialIcon } from "../../../../junctionAbs";
import {
	decodeStyle,
	getFileURL,
	mobile,
	parseStyle,
	tablet,
} from "../../../../juntion";
import log from "cslog";

function SocialIcons({ id, db, gs, device, dydb, ctx }) {
	const data = db[id];
	const { performAction, currentPage } = useAction();

	const ps = parseStyle(data, gs, data.cstate);

	log.d(ps, "SocialIcon PS");

	const styleIcon = decodeStyle(ps.styleGroup.icon, gs);
	const styleText = decodeStyle(ps.styleGroup.text, gs);

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	// const ss = decodeStyle(ps.style, gs);

	log.d(input, "Input in SocialIcons")

	let borderRadius = "10000px";
	if (input.frameShape.type === "square") {
		borderRadius = "0px";
	} else if (input.frameShape.type === "custom") {
		borderRadius = input.frameShape.value;
	}

	const type = input.socialItems?.type || "static"
	let items = Array.isArray(input.socialItems) ? input.socialItems : input.socialItems?.type === "static" ? input.socialItems?.data : []


	if (type === "dynamic") {
		const content = getContentObject(dydb, input.socialItems?.data?.source)
		items = parseDynamicSocialIcon(content);
	}

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: input.orientation === "h" ? "row" : "column",
					padding: "15px",
					justifyContent: input.alignItems,
					alignItems: input.alignItems,
					gap: `${input.itemGap - 0.5}rem`,
				}}
			>
				{items?.map((item, index) => {
					return (
						<span
							key={index}
							style={{
								...styleIcon,
								fontSize: input.iconSize.value,
								color: item.color || styleIcon.color,
								backgroundColor:
									input.frameType === "solid"
										? styleIcon.backgroundColor
										: "transparent",
								border:
									input.frameType === "frame"
										? `3px solid ${styleIcon.color}`
										: "none",
								borderRadius: borderRadius,
								width: input.orientation === "h" ? "auto" : input.iconSize.params * input.iconGap,
								height: input.iconSize.params * input.iconGap,
								display: "flex",
								// justifyContent: "center",
								justifyContent: "flex-start",
								alignItems: "center",
								// alignItems: "flex-start",
								cursor: "pointer",
								gap: "0.3em"
							}}
							onClick={() => {
								performAction(item.action);
							}}
						>
							<i className={item.icon?.value}></i>
							{input.showText && <p style={{
								color: "black",
								fontSize: "0.8em",
								whiteSpace: "nowrap",
								...styleText
							}}>
								{/* {item.text} */}
								{getContent(dydb, item.text || "")}
							</p>}
						</span>
					);
				})}
			</div>
		</div>
	);
}

export default SocialIcons;
